exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mergeDataSpinnerContainer > div {\n  width: 72px;\n  display: inline-block;\n  padding: 0 8px !important;\n}\n", ""]);

// exports
